import { useMyMutation, MutationInfos, client, Options } from '../helpers';
import { CreatePromotionInput } from '../../apiTypes';
import { typePromotions } from './types';
import { ToastWithIcon } from '../../../navigation/routes/toastProvider';
import { stringsRes } from '../../../resources/strings';

// Mutation function
function createPromotion(variables: CreatePromotionInput): MutationInfos {
    return {
        method: 'post',
        path: `/promotions`,
        type: typePromotions.CREATE_PROMOTION,
        params: {
            ...variables,
        },
    };
}

//= =========================//
//= ======== Hooks ==========//
//= =========================//

export function useCreatePromotion(options?: Options<CreatePromotionInput>) {
    return useMyMutation(createPromotion, {
        retry: 0,
        onSuccess: () => {
            // Update some cache with this key ref
            client.invalidateQueries('promotions');
            ToastWithIcon('info', stringsRes.common.added);
        },
        ...options,
    });
}
